/* Fathom Thread v1: trang sản phẩm (section ft-product).
   Chọn biến thể (size không chọn sẵn) · ảnh · bảng tổng tiền (nghe oh:extra từ form app) · thêm vào giỏ (multipart, có file logo)
   · Find your fit (so áo khách trải phẳng với bảng size của style, cm) · bảng size · rewards (chỉ hiển thị ước tính). */
(function () {
  'use strict';
  if (window.FtProduct) return;

  var CUR = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
  function money(cents) {
    try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: CUR }).format(cents / 100); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  }
  function $(root, sel) { return root.querySelector(sel); }
  function $$(root, sel) { return [].slice.call(root.querySelectorAll(sel)); }
  var IN = 2.54;

  function FtProduct(root) {
    this.root = root;
    this.variants = JSON.parse($(root, '[data-ftp-variants]').textContent);
    var ch = $(root, '[data-ftp-chart]');
    this.chart = ch ? JSON.parse(ch.textContent) : null;
    this.sizePos = parseInt(root.getAttribute('data-size-pos'), 10) || 0;
    this.colorPos = parseInt(root.getAttribute('data-color-pos'), 10) || 0;
    this.rate = parseFloat(root.getAttribute('data-rewards')) || 0;
    this.form = $(root, 'form.ftp__form');
    this.extra = { cents: 0, lines: [] };
    this.qty = 1;
    this.opts = [null, null, null];
    var idv = parseInt($(root, '[data-ftp-id]').value, 10);
    var cur = idv ? this.variants.filter(function (v) { return v.id === idv; })[0] : null;
    if (cur) this.opts = [cur.option1, cur.option2, cur.option3];
    else if (this.colorPos) {
      var fa = this.variants.filter(function (v) { return v.available; })[0] || this.variants[0];
      this.opts[this.colorPos - 1] = fa['option' + this.colorPos];
    }
    this.minPrice = Math.min.apply(null, this.variants.map(function (v) { return v.price; }));
    this.bindStickyBar();
    this.bindOptions(); this.bindGallery(); this.bindSummary(); this.bindSubmit(); this.bindSheets(); this.bindFit();
    this.refresh(false);
  }

  /* ---------- biến thể ---------- */
  FtProduct.prototype.variant = function () {
    var o = this.opts, n = this.variants[0].options.length;
    for (var i = 0; i < n; i++) if (o[i] == null) return null;
    return this.variants.filter(function (v) { return v.options.every(function (x, i) { return x === o[i]; }); })[0] || null;
  };
  FtProduct.prototype.bindOptions = function () {
    var self = this;
    $$(this.root, '[data-ftp-opt]').forEach(function (fs) {
      var pos = parseInt(fs.getAttribute('data-ftp-opt'), 10);
      $$(fs, '[data-ftp-val]').forEach(function (b) {
        b.addEventListener('click', function () {
          if (b.getAttribute('aria-disabled') === 'true') return;
          self.opts[pos - 1] = b.getAttribute('data-ftp-val');
          fs.classList.remove('is-invalid');
          var e = $(fs, '[data-ftp-size-err]'); if (e) e.textContent = '';
          self.refresh(true, pos === self.colorPos);
        });
      });
    });
  };
  FtProduct.prototype.selectSize = function (val) {
    if (!this.sizePos) return;
    this.opts[this.sizePos - 1] = val;
    var fs = $(this.root, '[data-ftp-opt="' + this.sizePos + '"]');
    if (fs) { fs.classList.remove('is-invalid'); var e = $(fs, '[data-ftp-size-err]'); if (e) e.textContent = ''; }
    this.refresh(true);
  };
  FtProduct.prototype.refresh = function (pushUrl, colorChanged) {
    var self = this, v = this.variant();
    $$(this.root, '[data-ftp-opt]').forEach(function (fs) {
      var pos = parseInt(fs.getAttribute('data-ftp-opt'), 10);
      var sel = $(fs, '[data-ftp-sel="' + pos + '"]'); if (sel) sel.textContent = self.opts[pos - 1] || '';
      $$(fs, '[data-ftp-val]').forEach(function (b) {
        var val = b.getAttribute('data-ftp-val');
        b.setAttribute('aria-checked', self.opts[pos - 1] === val ? 'true' : 'false');
        // còn hàng với các lựa chọn khác đang chọn?
        var test = self.opts.slice(); test[pos - 1] = val;
        var cands = self.variants.filter(function (x) { return x.options.every(function (o, i) { return i === pos - 1 || test[i] == null || o === test[i]; }) && x['option' + pos] === val; });
        var avail = cands.some(function (x) { return x.available; });
        b.setAttribute('aria-disabled', cands.length && !avail ? 'true' : 'false');
        var sm = $(b, '[data-ftp-delta]');
        if (sm) {
          var p = cands.length ? Math.min.apply(null, cands.map(function (x) { return x.price; })) : 0;
          sm.textContent = cands.length && !avail ? 'Sold out' : (p > self.minPrice ? '+' + money(p - self.minPrice).replace('.00', '') : '');
        }
      });
    });
    $(this.root, '[data-ftp-id]').value = v ? v.id : '';
    var priceEl = $(this.root, '[data-ftp-price]');
    if (v) priceEl.textContent = money(v.price);
    var was = $(this.root, '[data-ftp-was]');
    if (was) { if (v && v.compare_at_price > v.price) { was.textContent = money(v.compare_at_price); was.hidden = false; } else was.hidden = true; }
    if (v && pushUrl && history.replaceState) {
      try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.toString()); } catch (e) {}
    }
    if (colorChanged) {
      var any = v || this.variants.filter(function (x) { return x['option' + self.colorPos] === self.opts[self.colorPos - 1]; })[0];
      if (any && any.featured_media) this.goToMedia(any.featured_media.id);
    }
    this.updateTotals();
  };

  FtProduct.prototype.bindStickyBar = function () {
    var bar = $(this.root, '[data-ftp-bar]'), main = $(this.root, '[data-ftp-maincta]');
    if (!bar || !main || !window.IntersectionObserver) return;
    new IntersectionObserver(function (es) { es.forEach(function (e) { bar.classList.toggle('is-hidden', e.isIntersecting); }); }).observe(main);
  };

  /* ---------- ảnh ---------- */
  FtProduct.prototype.bindGallery = function () {
    var self = this, track = $(this.root, '[data-ftp-track]'); if (!track) return;
    this.slides = $$(track, '[data-ftp-slide]');
    var count = $(this.root, '[data-ftp-count]'), thumbs = $$(this.root, '[data-ftp-thumb]');
    var idx = 0, t = null;
    function off(i) { return self.slides[i].offsetLeft - self.slides[0].offsetLeft; }
    function cur() { var x = track.scrollLeft, best = 0, d = 1e9; for (var i = 0; i < self.slides.length; i++) { var k = Math.abs(off(i) - x); if (k < d) { d = k; best = i; } } return best; }
    function paint() { idx = cur(); if (count) count.textContent = (idx + 1) + ' / ' + self.slides.length; thumbs.forEach(function (b, i) { b.classList.toggle('is-on', i === idx); }); }
    track.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(paint, 60); }, { passive: true });
    this.goTo = function (i) {
      i = Math.max(0, Math.min(self.slides.length - 1, i));
      if (track.scrollWidth <= track.clientWidth + 2) { self.slides[i].scrollIntoView({ behavior: 'smooth', block: 'nearest' }); return; }
      track.scrollTo({ left: off(i), behavior: 'smooth' });
    };
    var pv = $(this.root, '[data-ftp-prev]'), nx = $(this.root, '[data-ftp-next]');
    if (pv) pv.addEventListener('click', function () { self.goTo(cur() - 1); });
    if (nx) nx.addEventListener('click', function () { self.goTo(cur() + 1); });
    thumbs.forEach(function (b) { b.addEventListener('click', function () { self.goTo(parseInt(b.getAttribute('data-ftp-thumb'), 10)); }); });
    track.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') { e.preventDefault(); self.goTo(cur() + 1); } else if (e.key === 'ArrowLeft') { e.preventDefault(); self.goTo(cur() - 1); } });
  };
  FtProduct.prototype.goToMedia = function (id) {
    if (!this.slides || !this.goTo) return;
    for (var i = 0; i < this.slides.length; i++) if (String(this.slides[i].getAttribute('data-media-id')) === String(id)) { this.goTo(i); return; }
  };

  /* ---------- tổng tiền ---------- */
  FtProduct.prototype.bindSummary = function () {
    var self = this;
    this.root.addEventListener('oh:extra', function (e) { self.extra = { cents: (e.detail && e.detail.cents) || 0, lines: (e.detail && e.detail.lines) || [] }; self.updateTotals(); });
    $$(this.root, '[data-ftp-q]').forEach(function (b) {
      b.addEventListener('click', function () { self.qty = Math.max(1, Math.min(99, self.qty + parseInt(b.getAttribute('data-ftp-q'), 10))); self.updateTotals(); });
    });
  };
  FtProduct.prototype.updateTotals = function () {
    var self = this, v = this.variant(), base = v ? v.price : this.minPrice;
    var each = base + this.extra.cents, total = each * this.qty;
    var linesEl = $(this.root, '[data-ftp-lines]');
    $$(linesEl, '[data-ftp-extra]').forEach(function (n) { n.remove(); });
    $(this.root, '[data-ftp-base]').textContent = money(base);
    this.extra.lines.forEach(function (l) {
      var d = document.createElement('div'); d.setAttribute('data-ftp-extra', '');
      var dt = document.createElement('dt'); dt.textContent = l.label;
      if (l.value) { var sm = document.createElement('span'); sm.className = 'ftp__line-v'; sm.textContent = l.value; dt.appendChild(sm); }
      var dd = document.createElement('dd'); dd.textContent = money(l.cents);
      d.appendChild(dt); d.appendChild(dd); linesEl.appendChild(d);
    });
    $(this.root, '[data-ftp-qty]').textContent = String(this.qty);
    $(this.root, '[data-ftp-qty-input]').value = String(this.qty);
    $(this.root, '[data-ftp-total]').textContent = money(total);
    $(this.root, '[data-ftp-barprice]').textContent = money(total);
    var label = !v ? (this.sizePos ? 'Choose your size' : 'Choose options') : (v.available ? 'Add to cart' : 'Sold out');
    $$(this.root, '[data-ftp-cta]').forEach(function (c) { if (!c.hasAttribute('aria-busy')) c.textContent = label; });
    if (this.rate) {
      var earn = Math.round(total * this.rate / 100);
      ['[data-ftp-earn]', '[data-ftp-earn2]', '[data-ftp-earn3]'].forEach(function (s) { var n = $(self.root, s); if (n) n.textContent = money(earn); });
    }
  };

  /* ---------- thêm vào giỏ ---------- */
  FtProduct.prototype.bindSubmit = function () {
    var self = this, form = this.form; if (!form) return;
    // Pha bubble: form app (pha capture) đã kiểm ô custom và ghi _fathom trước khi tới đây.
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var v = self.variant(), err = $(self.root, '[data-ftp-formerr]'), ctas = $$(self.root, '[data-ftp-cta]');
      err.hidden = true;
      if (!v) {
        var fs = $(self.root, '[data-ftp-opt="' + (self.sizePos || 1) + '"]');
        if (fs) {
          fs.classList.add('is-invalid');
          var se = $(fs, '[data-ftp-size-err]'); if (se) se.textContent = 'Choose your size to continue.';
          fs.scrollIntoView({ behavior: 'smooth', block: 'center' });
          var first = $(fs, '[data-ftp-val]:not([aria-disabled="true"])'); if (first) setTimeout(function () { try { first.focus({ preventScroll: true }); } catch (x) {} }, 300);
        }
        return;
      }
      if (!v.available) { err.textContent = 'This size is sold out. Choose another size.'; err.hidden = false; return; }
      if (ctas.some(function (c) { return c.hasAttribute('aria-busy'); })) return;
      ctas.forEach(function (c) { c.setAttribute('aria-busy', 'true'); c.disabled = true; c.textContent = 'Adding…'; });
      fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart/add.js', { method: 'POST', body: self.formData(), headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add to cart.'); return j; }); })
        .then(function () { ctas.forEach(function (c) { c.textContent = 'Added'; }); location.href = self.root.getAttribute('data-cart-url') || '/cart'; })
        .catch(function (x) {
          ctas.forEach(function (c) { c.removeAttribute('aria-busy'); c.disabled = false; }); self.updateTotals();
          err.textContent = (x && x.message) || 'Could not add to cart. Please try again.'; err.hidden = false;
        });
    });
  };

  // FormData của form, bỏ thuộc tính rỗng (ô custom để trống không được hiện trong giỏ/đơn).
  FtProduct.prototype.formData = function () {
    var fd = new FormData(this.form), out = new FormData();
    fd.forEach(function (v, k) { if (k.indexOf('properties[') === 0 && typeof v === 'string' && v.trim() === '') return; out.append(k, v); });
    return out;
  };

  /* ---------- sheet ---------- */
  FtProduct.prototype.sheet = function (name) { return $(this.root, '[data-ftp-sheet="' + name + '"]'); };
  FtProduct.prototype.bindSheets = function () {
    var self = this;
    $$(this.root, '[data-ftp-open]').forEach(function (b) {
      b.addEventListener('click', function () {
        var what = b.getAttribute('data-ftp-open');
        if (what === 'chart' && self.sheet('fit')) { self.fitGo('chart', true); window.FtSheet.open(self.sheet('fit'), b); return; }
        if (what === 'fit') { self.fitGo('method', true); }
        window.FtSheet.open(self.sheet(what), b);
      });
    });
  };

  /* ---------- Find your fit ---------- */
  FtProduct.prototype.sizesInChart = function () {
    var self = this, rows = this.chart.rows, offered = null;
    if (this.sizePos) offered = this.variants.map(function (v) { return v['option' + self.sizePos]; });
    return Object.keys(rows).filter(function (k) { return !offered || offered.indexOf(k) > -1; }).map(function (k) { return { size: k, w: rows[k][0], l: rows[k][1] }; });
  };
  FtProduct.prototype.fmt = function (cm) {
    var v = this.unit === 'in' ? cm / IN : cm;
    return (Math.round(v * 10) / 10).toString() + (this.unit === 'in' ? ' in' : ' cm');
  };
  FtProduct.prototype.fitGo = function (step, reset) {
    var sh = this.sheet('fit'); if (!sh) return;
    if (reset) this.fitStack = [];
    else if (this.fitStep && this.fitStep !== step) this.fitStack.push(this.fitStep);
    this.showStep(step);
  };
  FtProduct.prototype.showStep = function (step) {
    var sh = this.sheet('fit');
    this.fitStep = step;
    $$(sh, '[data-fit-step]').forEach(function (n) { n.hidden = n.getAttribute('data-fit-step') !== step; });
    var titles = { method: 'Find your fit', measure: 'Compare your shirt', result: 'Your closest match', nomatch: 'Your closest match', compare: '', chart: 'Size chart' };
    var t = titles[step]; if (step === 'compare' && this.cmp) t = this.cmp[0].size + ' or ' + this.cmp[1].size + '?';
    $(sh, '[data-fit-title]').textContent = t;
    $(sh, '[data-fit-back]').hidden = !this.fitStack.length;
    if (step === 'chart') this.renderChart();
    var box = $(sh, '.ft-sheet__box'); if (box) box.scrollTop = 0;
  };
  FtProduct.prototype.bindFit = function () {
    var self = this, sh = this.sheet('fit'); if (!sh || !this.chart) return;
    this.unit = 'in'; this.fitStack = []; this.pref = 'regular';
    var w = $(sh, '[data-fit-w]'), l = $(sh, '[data-fit-l]'), err = $(sh, '[data-fit-err]');
    $$(sh, '[data-fit-go]').forEach(function (b) { b.addEventListener('click', function () { self.fitGo(b.getAttribute('data-fit-go')); }); });
    $(sh, '[data-fit-back]').addEventListener('click', function () { var prev = self.fitStack.pop(); if (prev) self.showStep(prev); });
    $$(sh, '[data-fit-unit]').forEach(function (b) {
      b.addEventListener('click', function () {
        var u = b.getAttribute('data-fit-unit'); if (u === self.unit) return;
        [w, l].forEach(function (inp) { var n = parseFloat(String(inp.value).replace(',', '.')); if (!isNaN(n)) inp.value = String(Math.round((u === 'cm' ? n * IN : n / IN) * 10) / 10); });
        self.unit = u;
        $$(sh, '[data-fit-unit]').forEach(function (x) { x.setAttribute('aria-checked', x.getAttribute('data-fit-unit') === u ? 'true' : 'false'); });
        $$(sh, '[data-fit-u]').forEach(function (x) { x.textContent = u; });
        if (self.fitStep === 'chart') self.renderChart();
        if (self.lastResult && (self.fitStep === 'result' || self.fitStep === 'compare')) { self.renderResult(); if (self.fitStep === 'compare') self.renderCompare(); }
      });
    });
    $$(sh, '[data-fit-pref]').forEach(function (b) {
      b.addEventListener('click', function () { self.pref = b.getAttribute('data-fit-pref'); $$(sh, '[data-fit-pref]').forEach(function (x) { x.setAttribute('aria-checked', x === b ? 'true' : 'false'); }); });
    });
    $(sh, '[data-fit-find]').addEventListener('click', function () {
      var wn = parseFloat(String(w.value).replace(',', '.')), ln = parseFloat(String(l.value).replace(',', '.'));
      var toCm = self.unit === 'in' ? IN : 1;
      var wc = wn * toCm, lc = ln * toCm;
      var msg = '';
      if (isNaN(wn) || isNaN(ln)) msg = 'Enter both measurements as numbers.';
      else if (wc < 25 || wc > 110) msg = 'Chest width looks off. Measure armpit to armpit, laid flat (for example 22 in).';
      else if (lc < 40 || lc > 115) msg = 'Body length looks off. Measure from the high shoulder to the hem (for example 29 in).';
      err.textContent = msg;
      if (msg) return;
      self.measure(wc, lc);
    });
    $(sh, '[data-fit-use]').addEventListener('click', function () {
      if (!self.lastResult) return;
      self.useSize(self.lastResult.best.size);
    });
    $(sh, '[data-cmp-cards]').addEventListener('click', function (e) {
      var b = e.target.closest('[data-cmp-use]'); if (b) self.useSize(b.getAttribute('data-cmp-use'));
    });
  };
  FtProduct.prototype.measure = function (wc, lc) {
    var rows = this.sizesInChart(); if (!rows.length) return;
    var minW = Math.min.apply(null, rows.map(function (r) { return r.w; })), maxW = Math.max.apply(null, rows.map(function (r) { return r.w; }));
    var minL = Math.min.apply(null, rows.map(function (r) { return r.l; })), maxL = Math.max.apply(null, rows.map(function (r) { return r.l; }));
    if (wc < minW - 4 || wc > maxW + 4 || lc < minL - 8 || lc > maxL + 8) { this.lastResult = null; this.fitGo('nomatch'); return; }
    // Bề ngang quan trọng hơn chiều dài (trọng số 2:1). Relaxed = chỉ xét size không chật hơn áo khách.
    function score(r) { return Math.abs(r.w - wc) * 2 + Math.abs(r.l - lc); }
    var pool = this.pref === 'relaxed' ? rows.filter(function (r) { return r.w >= wc - 0.5; }) : rows;
    if (!pool.length) pool = rows;
    var best = pool.slice().sort(function (a, b) { return score(a) - score(b); })[0];
    var i = rows.indexOf(best), next = rows[i + 1] || null;
    this.lastResult = { w: wc, l: lc, best: best, next: next, rows: rows };
    this.renderResult();
    this.fitGo('result');
  };
  FtProduct.prototype.deltaText = function (d, more, less, dim) {
    if (Math.abs(d) < 0.3) return 'About the same ' + dim;
    return this.fmt(Math.abs(d)) + ' ' + (d > 0 ? more : less);
  };
  FtProduct.prototype.isAvail = function (size) {
    var self = this;
    return this.variants.some(function (v) { return v['option' + self.sizePos] === size && v.available && (!self.colorPos || v['option' + self.colorPos] === self.opts[self.colorPos - 1]); });
  };
  FtProduct.prototype.renderResult = function () {
    var r = this.lastResult, sh = this.sheet('fit'), b = r.best;
    $(sh, '[data-fit-size]').textContent = b.size;
    $(sh, '[data-fit-col]').textContent = 'Size ' + b.size;
    var self = this;
    $(sh, '[data-fit-rows]').innerHTML = '';
    [['Chest width', r.w, b.w], ['Body length', r.l, b.l]].forEach(function (x) {
      var tr = document.createElement('tr');
      [x[0], self.fmt(x[1]), self.fmt(x[2])].forEach(function (c, i) { var td = document.createElement('td'); td.textContent = c; if (i === 2) td.className = 'is-hl'; tr.appendChild(td); });
      $(sh, '[data-fit-rows]').appendChild(tr);
    });
    var ul = $(sh, '[data-fit-deltas]'); ul.innerHTML = '';
    [this.deltaText(b.w - r.w, 'wider across the chest', 'narrower across the chest', 'width'), this.deltaText(b.l - r.l, 'longer through the body', 'shorter through the body', 'length')].forEach(function (t) { var li = document.createElement('li'); li.textContent = t; ul.appendChild(li); });
    var avail = this.isAvail(b.size);
    var use = $(sh, '[data-fit-use]');
    use.textContent = avail ? 'Use size ' + b.size : 'Size ' + b.size + ' is sold out';
    use.disabled = !avail;
    var cmpBtn = $(sh, '[data-fit-compare], [data-fit-go="compare"]');
    if (r.next) { this.cmp = [b, r.next]; $(sh, '[data-fit-cmp-label]').textContent = 'Compare ' + b.size + ' and ' + r.next.size; cmpBtn.hidden = false; this.renderCompare(); }
    else { this.cmp = null; cmpBtn.hidden = true; }
  };
  FtProduct.prototype.renderCompare = function () {
    if (!this.cmp || !this.lastResult) return;
    var self = this, sh = this.sheet('fit'), r = this.lastResult, a = this.cmp[0], b = this.cmp[1];
    $(sh, '[data-cmp-a]').textContent = a.size; $(sh, '[data-cmp-b]').textContent = b.size;
    var tb = $(sh, '[data-cmp-rows]'); tb.innerHTML = '';
    [['Chest width', r.w, a.w, b.w], ['Body length', r.l, a.l, b.l]].forEach(function (x) {
      var tr = document.createElement('tr');
      [x[0], self.fmt(x[1]), self.fmt(x[2]), self.fmt(x[3])].forEach(function (c, i) { var td = document.createElement('td'); td.textContent = c; if (i === 2) td.className = 'is-hl'; tr.appendChild(td); });
      tb.appendChild(tr);
    });
    var cards = $(sh, '[data-cmp-cards]'); cards.innerHTML = '';
    [[a, 'closer to your current shirt', true], [b, 'more room', false]].forEach(function (x) {
      var s = x[0], d = document.createElement('div'); d.className = 'fit-cmp-card' + (x[2] ? ' is-best' : '');
      var h = document.createElement('b'); h.textContent = s.size + ': ' + x[1];
      var p = document.createElement('span'); p.textContent = self.deltaText(s.w - r.w, 'wider', 'narrower', 'width') + ' and ' + self.deltaText(s.l - r.l, 'longer', 'shorter', 'length').replace('About the same', 'about the same');
      var btn = document.createElement('button'); btn.type = 'button'; btn.className = 'ft-btn ft-btn--block ' + (x[2] ? 'ft-btn--cta' : 'ft-btn--outline');
      var av = self.isAvail(s.size); btn.textContent = av ? 'Choose ' + s.size : s.size + ' sold out'; btn.disabled = !av; btn.setAttribute('data-cmp-use', s.size);
      d.appendChild(h); d.appendChild(p); d.appendChild(btn); cards.appendChild(d);
    });
  };
  FtProduct.prototype.renderChart = function () {
    var self = this, sh = this.sheet('fit'), tb = $(sh, '[data-chart-rows]'); if (!tb) return;
    tb.innerHTML = '';
    var sel = this.sizePos ? this.opts[this.sizePos - 1] : null;
    this.sizesInChart().forEach(function (r) {
      var tr = document.createElement('tr'); if (r.size === sel) tr.className = 'is-hl';
      [r.size, self.fmt(r.w), self.fmt(r.l)].forEach(function (c) { var td = document.createElement('td'); td.textContent = c; tr.appendChild(td); });
      tb.appendChild(tr);
    });
  };
  FtProduct.prototype.useSize = function (size) {
    this.selectSize(size);
    window.FtSheet.close(this.sheet('fit'));
    var fs = $(this.root, '[data-ftp-opt="' + this.sizePos + '"]');
    if (fs) {
      fs.scrollIntoView({ behavior: 'smooth', block: 'center' });
      var e = $(fs, '[data-ftp-size-err]');
      if (e) { e.style.color = 'var(--ft-ink)'; e.textContent = 'Size ' + size + ' selected from your measurements.'; setTimeout(function () { if (e.textContent.indexOf('selected') > -1) { e.textContent = ''; e.style.color = ''; } }, 4000); }
    }
  };

  /* Ngày giao ước tính: hôm nay + 10 đến 14 ngày (ngày lịch, chủ store chốt 16/10). Chỉ là ước tính hiển thị. */
  function dayAdd(d, n) { var x = new Date(d.getTime()); x.setDate(x.getDate() + n); return x; }
  function range(t) { var m = String(t || '').match(/(\d+)\s*[-–to ]+\s*(\d+)/); return m ? [parseInt(m[1], 10), parseInt(m[2], 10)] : null; }
  function etaInit(root) {
    var box = root.querySelector('[data-ftp-eta]'), out = root.querySelector('[data-ftp-eta-text]'); if (!box || !out) return;
    var r = range(box.getAttribute('data-eta')); if (!r) return;
    var now = new Date(), a = dayAdd(now, r[0]), b = dayAdd(now, r[1]);
    var fmt = function (d) { try { return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }); } catch (e) { return (d.getMonth() + 1) + '/' + d.getDate(); } };
    out.textContent = fmt(a) + ' to ' + fmt(b);
  }
  /* Đã xem gần đây: lưu handle trong trình duyệt (tối đa 8), hiện các SP khác qua /products/<handle>.js */
  function rvInit(root) {
    var sec = document.querySelector('[data-ftp-rv]'); if (!sec) return;
    var me = sec.getAttribute('data-ftp-rv'), key = 'ft_rv', list = [];
    try { list = JSON.parse(localStorage.getItem(key) || '[]'); } catch (e) { list = []; }
    if (!Array.isArray(list)) list = [];
    var others = list.filter(function (h) { return h && h !== me; }).slice(0, 6);
    var next = [me].concat(list.filter(function (h) { return h !== me; })).slice(0, 8);
    try { localStorage.setItem(key, JSON.stringify(next)); } catch (e) {}
    if (!others.length) return;
    var row = sec.querySelector('[data-ftp-rv-row]'), cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    var money = function (c) { try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: cur }).format(c / 100); } catch (e) { return '$' + (c / 100).toFixed(2); } };
    var root0 = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    Promise.all(others.map(function (h) { return fetch(root0 + 'products/' + encodeURIComponent(h) + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }); }))
      .then(function (ps) {
        ps = ps.filter(function (x) { return x && x.available; }); if (!ps.length) return;
        ps.forEach(function (x) {
          var a = document.createElement('div'); a.className = 'ftp-rel__item';
          var img = x.featured_image ? x.featured_image + (x.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=500' : '';
          a.innerHTML = '<article class="ftk"><a class="ftk__img" href="' + x.url + '" tabindex="-1" aria-hidden="true">' + (img ? '<img src="' + img + '" alt="" loading="lazy" width="500" height="500">' : '') + '</a>' +
            '<h3 class="ftk__title"><a href="' + x.url + '"></a></h3><p class="ftk__price">' + (x.price_varies ? 'From ' : '') + money(x.price_min) + '</p></article>';
          a.querySelector('.ftk__title a').textContent = x.title;
          row.appendChild(a);
        });
        sec.hidden = false;
      });
  }
  /* Nhãn giá nhỏ dưới nút "Add my name" (như nhãn FREE của Netmantos): giá thấp nhất trong các ô của form */
  function ribbonInit(root) {
    var btns = root.querySelectorAll('.fc-modebtn'); if (btns.length < 2) return;
    var min = null;
    root.querySelectorAll('.fc-lprice').forEach(function (e) { var v = parseFloat(String(e.textContent).replace(/[^0-9.]/g, '')); if (v > 0 && (min === null || v < min)) min = v; });
    if (min === null) return;
    var b = btns[btns.length - 1]; if (b.querySelector('.ftp-rib')) return;
    var r = document.createElement('span'); r.className = 'ftp-rib'; r.textContent = 'From +$' + min.toFixed(2); b.appendChild(r);
  }

  window.FtProduct = FtProduct;
  function init() {
    document.querySelectorAll('[data-ft-pdp]:not([data-ftp-ready])').forEach(function (r) {
      r.setAttribute('data-ftp-ready', '1');
      try { new FtProduct(r); } catch (e) { console.error('FtProduct', e); }
      try { etaInit(r); rvInit(r); ribbonInit(r); setTimeout(function () { ribbonInit(r); }, 1200); } catch (e) { console.error('FtProduct extras', e); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
